import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DFE8F9",
      d: "M17.2 5c.7-.05 1.42.13 2.04.46l7.22 4.52c.89.64 1.45 1.66 1.54 2.76v9.52c-.08 1-.54 1.91-1.29 2.57-2.4 1.5-4.76 3.14-7.21 4.56-1.22.7-2.47.86-3.76.23l-7.33-4.57c-.9-.65-1.47-1.64-1.57-2.76v-9.57c.1-1.15.71-2.18 1.66-2.82 2.32-1.36 4.56-2.96 6.89-4.3.57-.33 1.14-.54 1.8-.58z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "m16.05 7.9-.2.72 4.35 1.24-4.15 1.18-4.14-1.18 4.34-1.24-.21-.72-.21-.72-6.88 1.96a.75.75 0 0 0 0 1.44l6.88 1.96c.13.04.28.04.41 0l6.9-1.96a.76.76 0 0 0 .55-.72c0-.33-.22-.63-.55-.72l-6.9-1.96a.7.7 0 0 0-.41 0l.21.72z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M9.28 9.83v3.46c0 .36.29.65.65.65s.65-.29.65-.65V9.83c0-.36-.29-.65-.65-.65s-.65.29-.65.65M9.71 23.92c.37-1.01 1.17-1.92 2.28-2.58s2.52-1.07 4.06-1.07c1.53 0 2.92.4 4.03 1.05s1.91 1.55 2.29 2.55c.15.39.58.58.97.43s.58-.58.43-.97c-.53-1.37-1.58-2.5-2.93-3.3s-3.01-1.26-4.79-1.26c-1.8 0-3.47.47-4.83 1.28-1.35.81-2.41 1.97-2.92 3.35-.14.39.06.82.44.96s.82-.06.96-.44zM19.01 11.41c.33.53.52 1.16.52 1.83 0 1.93-1.56 3.48-3.49 3.49-1.93 0-3.48-1.56-3.49-3.49 0-.72.21-1.38.58-1.93.23-.34.14-.81-.21-1.04a.746.746 0 0 0-1.04.21 4.94 4.94 0 0 0-.84 2.76 4.991 4.991 0 1 0 9.24-2.62.747.747 0 1 0-1.27.79"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "m6.81 23.99 7.11 4.44c.64.4 1.36.6 2.09.6s1.45-.2 2.09-.6l7.11-4.44a3.87 3.87 0 0 0 1.83-3.29v-9.39c0-1.34-.69-2.58-1.83-3.29-.3-.19-.71-.1-.9.21s-.1.71.21.9c.76.48 1.22 1.3 1.22 2.19v9.39c0 .89-.46 1.72-1.22 2.19l-7.11 4.44c-.43.27-.91.4-1.4.4s-.97-.13-1.4-.4L7.5 22.9c-.3-.19-.71-.1-.9.21-.19.3-.1.71.21.9zm.69-1.11c-.76-.48-1.22-1.3-1.22-2.19V11.3c0-.89.46-1.72 1.22-2.19l7.11-4.44c.43-.27.91-.4 1.4-.4s.97.13 1.4.4l7.11 4.44c.3.19.71.1.9-.21.19-.3.1-.71-.21-.9L18.1 3.56c-.64-.4-1.36-.6-2.09-.6s-1.45.2-2.09.6L6.81 8a3.87 3.87 0 0 0-1.83 3.29v9.39c0 1.34.69 2.58 1.83 3.29.3.19.71.1.9-.21a.65.65 0 0 0-.21-.9z"
    }, null, -1)
  ]))]))
}
export default { render: render }